<template>
    <div class="flex flex-col gap-1">
        <label v-if="label" class="text-xs text-slate-500 dark:text-slate-400">{{ label }}</label>
        <InputText
            v-model="value"
            :disabled="disabled"
            :invalid="!!errorMessage"
            :placeholder="label"
            :type="type ?? 'text'"
            fluid
        />
        <small v-if="errorMessage" class="text-red-400">{{ errorMessage }}</small>
    </div>
</template>

<script lang="ts" setup>
    import { InputText } from 'primevue'
    import { useField } from 'vee-validate'
    import { toRef } from 'vue'

    const props = defineProps<{
        modelValue?: string
        label?:      string
        rules?:      string
        disabled?:   boolean
        type?:       string
        name?:       string
    }>()

    const emit = defineEmits<{ (e: 'update:modelValue', value: string): void }>()

    // Pass `label` so vee-validate renders the human field label in validation
    // messages ("Polje Geslo uporabnika je obvezno") instead of the raw field
    // name ("The su_password field is required").
    const { value, errorMessage } = useField<string>(
        toRef(() => props.name ?? props.label ?? 'field'),
        props.rules,
        { syncVModel: true, controlled: true, label: toRef(() => props.label) },
    )

    void emit
</script>
